<template>
  <div>
    <div class="image message-text__wrap">
      <img :src="url" @click="onClick" @error="onImgError()" />
      <woot-modal :full-width="true" :show.sync="show" :on-close="onClose">
        <img :src="url" class="modal-image skip-context-menu" />
      </woot-modal>
    </div>
    <div v-if="!!caption" class="caption-content message-text__wrap" >
      <div class="text-content">
        {{ caption }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    url: {
      type: String,
      required: true,
    },
    caption: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    onClose() {
      this.show = false;
    },
    onClick() {
      this.show = true;
    },
    onImgError() {
      this.$emit('error');
    },
  },
};
</script>
